import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 0 0 80px;\n  min-height: 80vh;\n  @media (max-width: 768px) {\n    /* background-color: #ffff; */\n    .active-tab-wrapper {\n      margin: 0 -16px;\n      padding: unset;\n      flex: 1;\n      display: flex;\n      align-items: center;\n      gap: unset;\n      overflow-x: auto;\n\n      li {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 12px 0;\n\n        > div {\n          font-size: 16px;\n          line-height: 24px;\n        }\n\n        &.active {\n          padding: 12px 0 10px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  flex: 1;\n\n  .section-title {\n    font-size: 20px;\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  margin-top: 32px;\n  border-radius: 6px;\n  box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n  padding: 24px;\n  background-color: white;\n  @media (max-width: 768px) {\n    box-shadow: none;\n    border-bottom: 8px solid ",
        ";\n    border-radius: 6px 6px 0 0;\n    margin: 0 -16px;\n    padding: 16px 16px 0;\n  }\n\n  .filter-area {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 24px;\n\n    @media (max-width: 768px) {\n      gap: 16px;\n      margin: 0 -16px;\n      padding-left: 16px;\n      padding-bottom: 16px;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: block;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: none;\n  @media (max-width: 768px) {\n    display: block;\n    margin: 0 -16px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n  font-size: 28px;\n  align-items: center;\n\n  > span {\n    padding: 0 8px;\n    border-radius: 6px;\n    background-color: ",
        ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, styled as muiStyled } from "@mui/material";
import styled from "styled-components";
import Icon from "../icon/Icon";
import { ArrowLeft, Sizes } from "../icon/IconList";
export const SearchPageWrapper = styled.div.withConfig({
    componentId: "sc-57e12b39-0"
})(_templateObject());
export const SearchListWrap = styled.div.withConfig({
    componentId: "sc-57e12b39-1"
})(_templateObject1());
export const SelectingArea = styled.div.withConfig({
    componentId: "sc-57e12b39-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_50);
export const FilterArea = styled.div.withConfig({
    componentId: "sc-57e12b39-3"
})(_templateObject3());
export const MobileSliderArea = styled.div.withConfig({
    componentId: "sc-57e12b39-4"
})(_templateObject4());
export const ActiveTabLabel = styled.div.withConfig({
    componentId: "sc-57e12b39-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_50);
export const FilterTitle = muiStyled("p")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "center",
        paddingRight: "16px",
        height: "38px",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "24px" /* 150% */ ,
        letterSpacing: "-0.16px"
    };
});
export const ButtonWithIcon = (param)=>{
    let { onClick  } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        onClick: onClick,
        color: "primary",
        sx: (theme)=>{
            return {
                p: "8px",
                height: "fit-content"
            };
        },
        "aria-label": "directions",
        children: /*#__PURE__*/ _jsx(Icon, {
            icon: ArrowLeft,
            size: Sizes.xmedium
        })
    });
};
export const renderKoreanFilterName = (key)=>{
    let result = "";
    switch(key){
        case "genres":
            result = "장르";
            break;
        case "eras":
            result = "시대";
            break;
        case "use_books":
        case "relatedBooks":
            result = "교재";
            break;
        case "brands":
        case "authors":
            result = "제작자";
            break;
        case "units":
            result = "단원";
            break;
        case "publishers":
        case "publishers[]":
        case "publisher":
            result = "출판사";
            break;
        case "data_types":
        case "dataTypes":
            result = "자료유형";
            break;
        case "content_types":
        case "contentTypes":
            result = "학습 내용";
            break;
        case "curriculums":
        case "curriculums[]":
        case "curriculum":
            result = "학년";
            break;
        case "subjects":
        case "subjects[]":
        case "subject":
            result = "과목";
            break;
        // 믹스패널 때문에 추가
        case "추천 카테고리":
            result = "추천 카테고리";
            break;
        case "편집가능":
            result = "편집가능";
            break;
        case "tickets":
            result = "이용권";
            break;
        case "solvookPasses":
            result = "쏠북패스";
            break;
        case "steps":
            result = "학습단계";
            break;
        default:
            result = key;
            break;
    }
    return result;
};
